module.exports = __webpack_public_path__ + "static/img/git@1x.d7827c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/git@1x.png
// module id = Km3E
// module chunks = 0